import { default as Image } from '@react/shared/components/Image';
import { LegalPageHeaderProps } from 'sly/legalPage/legalPageHeader/LegalPageHeader.types';
import Heading from 'sly/system/Heading';

export default function LegalPageHeader({ legalPage }: LegalPageHeaderProps) {
  const title = legalPage === 'privacy' ? 'Our Privacy Policy' : 'Terms of Use';
  const subtitle =
    'Helping families and individuals find the right senior living options';
  return (
    <div
      className='relative h-[40vh] max-h-[var(--col5)] bg-slate-base'
      data-tp-id='gen-div-0a545f07-2d3d-4cb4-b2cc-9944fd1b9654'
    >
      <Image
        path='react-assets/our-history/hero.jpg'
        alt={`${title} - ${subtitle}`}
        className='absolute left-0 top-0 z-0 h-full w-full object-cover opacity-80'
        layout='raw'
        height={600}
        width={400}
        priority
        data-tp-id='gen-Image-6ca294ec-5610-4a8c-8c70-d8053cabc2f1'
      />
      <div
        className='absolute left-0 top-0 flex h-full w-full flex-col justify-center'
        data-tp-id='gen-div-056f3dd2-4ce2-434c-873f-a4045689fd41'
      >
        <div
          className='my-0 mx-auto w-full py-0 px-4 md:w-[var(--col8)] md:p-0 lg:w-[var(--col12)]'
          data-tp-id='gen-div-1c1485cb-55c9-4cbb-83ea-783a1cd1cae5'
        >
          <Heading
            as='h1'
            className='mb-8 text-4xl font-medium leading-[1.33] text-white'
            font='font-t-s-azo'
            data-tp-id='gen-Heading-44d7499b-007e-469f-aaf7-597183a2f158'
          >
            {title}
          </Heading>
          <div
            className='text-xl font-medium leading-[1.6] text-white'
            data-tp-id='gen-div-4df4eb39-4b0c-4c13-8301-700ece2cd9b3'
          >
            {subtitle}
          </div>
        </div>
      </div>
    </div>
  );
}
